/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const TemplateGalleryAuctionIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.2895 20.0475L8.25557 7.50937V7.32274C8.25557 6.91555 7.98411 6.55926 7.59389 6.44049L5.72759 5.91454C4.59085 5.59218 3.4541 6.45746 3.4541 7.6451L3.48803 19.9457C3.48803 21.1333 4.62478 21.9816 5.77849 21.6593L7.62782 21.1164C8.01804 20.9976 8.2895 20.6413 8.2895 20.2341V20.0475Z"
      fill="currentColor"
    />
    <path
      d="M21.3536 10.3428L9.93524 7.10221C9.74861 7.05131 9.56198 7.18704 9.54502 7.39063C9.52805 7.59423 9.71468 7.8148 9.93524 7.8657C10.3085 7.95053 21.133 11.1572 21.133 11.1572C21.5402 11.2759 21.8286 11.6492 21.8286 12.0733V15.3309C21.8286 15.789 21.5232 16.1962 21.0821 16.3149C21.0821 16.3149 10.4273 19.5385 9.95221 19.7252C9.81648 19.7761 9.56198 19.9457 9.56198 20.1493C9.56198 20.3359 9.81648 20.4717 10.071 20.4038L21.3536 17.1293C22.1171 16.9087 22.643 16.1962 22.643 15.3987V12.0903C22.66 11.2759 22.134 10.5633 21.3536 10.3428Z"
      fill="currentColor"
    />
    <path
      d="M13.4984 19.1653C13.3627 19.1653 13.3118 19.3349 13.4475 19.4537L16.6202 21.6763C16.739 21.7611 16.8747 21.812 17.0274 21.812H17.0783C17.4346 21.812 17.7061 21.5236 17.7061 21.1673V17.9776L13.4984 19.1653Z"
      fill="currentColor"
    />
  </svg>
);
